import React, { useEffect, useState } from "react";
import { Button, Table } from "react-bootstrap";
import { getAllCallBetOrders } from "../../actions/gameSettings";
import { useSelector, useDispatch } from "react-redux";
import { momentFormat } from "../../lib/dateFormat";
import { formatOdds } from "../../../utility/odds";
import {
  callBetMarketLabel,
  formatCallBetBookLine,
  formatCallBetComparison,
  formatCallBetDesiredLine,
} from "../../../utility/callBetDisplay";
import WagerEditModal from "../WagerEditModal";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import Loader from "../Loader";

const Callbettable = () => {
    const accountData = useSelector((state) => state.account);
        const location = useLocation();
    const [show, setShow] = useState(false);
    const [allOrders, setAllOrders] = useState([]);
    const [orderItem, setOrderItem] = useState({});
    const [loading, setLoading] = useState(true);
    const [fetchError, setFetchError] = useState(null);
    const dispatch = useDispatch();

    const handleClose = () => {
        setOrderItem({});
        setShow(false);
    };

    const handleShow = (data) => {
        setOrderItem(data);
        setShow(true);
    };

    useEffect(() => {
        fetchAllOrders();
    }, [accountData, location.key]);

    const fetchAllOrders = async () => {
        if (!accountData?.emailId) {
            setLoading(false);
            setAllOrders([]);
            return;
        }
        setLoading(true);
        setFetchError(null);
        try {
            const { status, result, message } = await getAllCallBetOrders(
                { email: accountData.emailId },
                dispatch
            );
            if (status === true && Array.isArray(result)) {
                const sortedResult = [...result].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                setAllOrders(sortedResult);
            } else {
                setFetchError(message || "Unable to load call bets.");
                setAllOrders([]);
            }
        } catch (err) {
            console.log("err", err);
            setFetchError("Unable to load call bets. Please try again.");
            setAllOrders([]);
        } finally {
            setLoading(false);
        }
    };
    const renderRiskWin = (item) => {
        const risk = Number(item.wagerAmount || item.totalLossamount || 0);
        const payout = Number(item.payOut || item.totalWinamount || 0);
        const win = payout - risk;
        return (
            <p>
                ${risk.toFixed(2)} / ${win.toFixed(2)}
            </p>
        );
    };

    const callBetRowKey = (item, index) => {
        const tid = item?.ticketId;
        if (tid !== undefined && tid !== null && String(tid).length > 0) {
            return `callbet-${tid}-${item?.betType ?? "bet"}`;
        }
        return `callbet-fallback-${index}`;
    };

    return (
        <section>
            <div className="dashboard_content_sec">
                <div className="teams_table_sec openbet">
                    <div className="match_heading">CALL BET ORDERS</div>

                    {loading && (
                        <div className="py-5 d-flex justify-content-center">
                            <Loader />
                        </div>
                    )}
                    {!loading && fetchError && (
                        <p className="text-danger text-center py-4 mb-0">{fetchError}</p>
                    )}
                    {!loading && !fetchError && (
                    <Table responsive>
                        {allOrders.length > 0 && (
                            <thead>
                                <tr>
                                    <th>TICKET NO</th>
                                    <th>DATE PLACED</th>
                                    <th className="sportTh">SPORT</th>
                                    <th className="descTh">DESCRIPTION</th>
                                    <th>RISK / WIN ($)</th>
                                    <th>ACTIONS</th>
                                </tr>
                            </thead>
                        )}

                        {allOrders.length > 0 ? (
                            allOrders.map((item, index) => {
                                const { betType } = item;

                                // 🎯 STRAIGHT BET
                                if (betType === "Straight") {
                                    return (
                                        <tbody key={callBetRowKey(item, index)}>
                                            <tr className="match_collections">
                                                <td>
                                                    <Button
                                                        onClick={() => handleShow(item)}
                                                        className="open_wager_ticket_btn"
                                                    >
                                                        #{item.ticketId}
                                                    </Button>
                                                </td>

                                                <td>
                                                    <p>{momentFormat(item.createdAt)}</p>
                                                </td>

                                                <td>
                                                    <p>{item.sport_title || item.title}</p>
                                                </td>

                                                <td>
                                                    <p className="text-primary fw-bold">Straight · {callBetMarketLabel(item.oddType)}</p>
                                                    {item.homeTeam} vs {item.awayTeam}
                                                    <br />
                                                    {item.teamName}
                                                    <br />
                                                    {(() => {
                                                        const compare = formatCallBetComparison(item);
                                                        if (compare) {
                                                            return (
                                                                <span className="call-bet-table__compare">
                                                                    Book: {compare.book} → Your call: {compare.desired}
                                                                </span>
                                                            );
                                                        }
                                                        return (
                                                            <>
                                                                Target: {formatCallBetDesiredLine(item)}
                                                                <br />
                                                                Book: {formatCallBetBookLine(item)}
                                                            </>
                                                        );
                                                    })()}
                                                </td>

                                                <td>{renderRiskWin(item)}</td>

                                                <td>
                                                    <button
                                                        className="btn img_btn getbtn mt-3"
                                                        onClick={() => handleShow(item)}
                                                    >
                                                        Edit
                                                    </button>
                                                </td>
                                            </tr>

                                            {/* <tr>
                                                <td colSpan={12}>
                                                    <div className="d-flex justify-content-between match_total">
                                                        <h5 className="mb-0">CALL BETS</h5>
                                                    </div>
                                                </td>
                                            </tr> */}
                                        </tbody>
                                    );
                                }

                                return null;
                            })
                        ) : (
                            <tbody>
                                <tr>
                                    <td colSpan={6} className="text-center">
                                        NO CALL BETS
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </Table>
                    )}
                </div>
            </div>

            <WagerEditModal show={show} handleClose={handleClose} item={orderItem} refreshData={fetchAllOrders} />
        </section>
    );
};

export default Callbettable;
